(() => {
  const config = window.LumiGiftConfig || {};
  const giftVariantId = Number(config.variantId || 0);
  const threshold = Number(config.threshold || 1);
  let syncing = false;

  if (!giftVariantId) return;

  const cartUrl = window.routes?.cart_url || '/cart';
  const addUrl = window.routes?.cart_add_url || '/cart/add.js';
  const changeUrl = window.routes?.cart_change_url || '/cart/change.js';

  const getCart = () => fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  async function syncGift() {
    if (syncing) return false;
    syncing = true;
    try {
      const cart = await getCart();
      const giftItems = cart.items.filter((item) => Number(item.variant_id) === giftVariantId);
      const merchandiseSubtotal = cart.items.reduce((sum, item) => {
        return Number(item.variant_id) === giftVariantId ? sum : sum + Number(item.original_line_price || item.line_price || 0);
      }, 0);
      const qualifies = merchandiseSubtotal >= threshold;

      if (qualifies && giftItems.length === 0) {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: giftVariantId,
              quantity: 1,
              properties: { '_Lumi promotion': 'One free random squishy with every order' }
            }]
          })
        });
        if (!response.ok) throw new Error('Gift could not be added.');
        return true;
      }

      if (qualifies && giftItems.length > 0 && giftItems[0].quantity !== 1) {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItems[0].key, quantity: 1 })
        });
        if (!response.ok) throw new Error('Gift quantity could not be updated.');
        return true;
      }

      if (!qualifies && giftItems.length > 0) {
        const response = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItems[0].key, quantity: 0 })
        });
        if (!response.ok) throw new Error('Gift could not be removed.');
        return true;
      }

      return false;
    } catch (error) {
      console.warn('[Lumi gift]', error);
      return false;
    } finally {
      syncing = false;
    }
  }

  window.LumiSyncGift = syncGift;

  async function syncAndRefresh() {
    const changed = await syncGift();
    if (changed) window.location.reload();
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncAndRefresh();

    document.addEventListener('click', async (event) => {
      const checkoutButton = event.target.closest('#checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]');
      if (!checkoutButton) return;
      event.preventDefault();
      checkoutButton.disabled = true;
      await syncGift();
      window.location.assign('/checkout');
    }, true);

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
        window.setTimeout(syncAndRefresh, 250);
      });
    }
  });
})();
